export const PROFESSIONS_ROUTING = {
  professions: 'metiers',
  professionsView: `metiers/:professionId`,
  tabSlug: ':tabSlug',
} as const;
